export const defaultCardStyle = "bg-white rounded-lg ring-gray-300 lg:ring-1 shadow";
